var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFuel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1242_417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.25 0C1.4325 0 0.75 0.6825 0.75 1.5V17.25C0.75 17.4489 0.829018 17.6397 0.96967 17.7803C1.11032 17.921 1.30109 18 1.5 18H10.5C10.6989 18 10.8897 17.921 11.0303 17.7803C11.171 17.6397 11.25 17.4489 11.25 17.25V13.875C11.25 13.7755 11.2895 13.6802 11.3598 13.6098C11.4302 13.5395 11.5255 13.5 11.625 13.5H12C12.423 13.5 12.75 13.827 12.75 14.25V15C12.75 16.2337 13.7663 17.25 15 17.25C16.2338 17.25 17.25 16.2337 17.25 15V5.25C17.25 4.54275 16.9163 3.8745 16.35 3.45L13.95 1.65C13.7907 1.53104 13.5908 1.48004 13.394 1.50815C13.1972 1.53626 13.0196 1.64121 12.9 1.8C12.7812 1.95934 12.7304 2.1592 12.7585 2.35593C12.7866 2.55267 12.8914 2.73029 13.05 2.85L13.95 3.525C14.0431 3.59486 14.1187 3.68545 14.1708 3.78959C14.2229 3.89373 14.25 4.00857 14.25 4.125V6C14.25 6.6915 14.7353 7.2855 15.3795 7.4535C15.579 7.50525 15.75 7.668 15.75 7.875V15C15.75 15.423 15.423 15.75 15 15.75C14.577 15.75 14.25 15.423 14.25 15V14.25C14.25 13.0162 13.2338 12 12 12H11.625C11.5255 12 11.4302 11.9605 11.3598 11.8902C11.2895 11.8198 11.25 11.7245 11.25 11.625V1.5C11.25 0.6825 10.5675 0 9.75 0H2.25ZM2.625 1.5H9.375C9.58275 1.5 9.75 1.66725 9.75 1.875V7.125C9.75 7.33275 9.58275 7.5 9.375 7.5H2.625C2.57573 7.5001 2.52692 7.49047 2.48138 7.47166C2.43584 7.45285 2.39446 7.42523 2.35961 7.39039C2.32477 7.35554 2.29715 7.31416 2.27834 7.26862C2.25953 7.22308 2.2499 7.17427 2.25 7.125V1.875C2.25 1.66725 2.41725 1.5 2.625 1.5Z",
    fill: "#FA8C16"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1242_417"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuel);
export default __webpack_public_path__ + "static/media/fuel.f4f5a07a0321214f45340bb6db314ac4.svg";
export { ForwardRef as ReactComponent };